import FinAssetsModal from '@/common/containers/Modals/FinAssetsModal/FinAssetsModal';

export default FinAssetsModal;
